module.exports = "/build/web/svg/social/default/snapchat.0f7b9963ff5c5a247854b4dfb12e67f5.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/default/snapchat.svg
// module id = 185
// module chunks = 24